import React from 'react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const eur = (x) => `${Number(x || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
const STATUS = {
  paye: { label: 'Loyer payé', cls: 'bg-green-100 text-green-700', dot: 'bg-green-500' },
  attente: { label: 'En attente', cls: 'bg-yellow-100 text-yellow-700', dot: 'bg-yellow-500' },
  impaye: { label: 'Impayé', cls: 'bg-red-100 text-red-700', dot: 'bg-red-500' },
};
const periodLabel = (p) => {
  const [y, m] = (p || '').split('-');
  const months = ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'];
  return m ? `${months[parseInt(m, 10) - 1]} ${y}` : p;
};

export const ClientPortalGestion = ({ data }) => {
  const properties = data?.properties || [];
  if (properties.length === 0) {
    return <div className="realease-card p-8 text-center text-gray-400">Aucun bien en gestion locative associé à votre compte.</div>;
  }
  return (
    <div className="space-y-8" data-testid="portal-gestion">
      {properties.map(({ property: prop, rent_status, payments, documents, stats }) => {
        const st = STATUS[rent_status] || STATUS.attente;
        return (
          <div key={prop.property_id} data-testid={`portal-property-${prop.property_id}`}>
            <div className="flex items-start justify-between mb-4 flex-wrap gap-2">
              <div>
                <h2 className="text-xl font-bold text-gray-900">{prop.address}</h2>
                <p className="text-sm text-gray-500">Loyer {eur(prop.rent_amount)} CC — Gestion {prop.mgmt_pct}%</p>
              </div>
              <span className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium ${st.cls}`}>
                <span className={`w-2 h-2 rounded-full ${st.dot}`}></span>{st.label}
              </span>
            </div>

            <div className="grid grid-cols-3 gap-4 mb-6">
              <div className="realease-card p-4"><p className="text-xs text-gray-500 mb-1">Loyers perçus (année)</p><p className="text-lg font-bold text-gray-900">{eur(stats.total_received_year)}</p></div>
              <div className="realease-card p-4"><p className="text-xs text-gray-500 mb-1">Honoraires (année)</p><p className="text-lg font-bold text-gray-900">{eur(stats.total_fees_year)}</p></div>
              <div className="realease-card p-4"><p className="text-xs text-gray-500 mb-1">Net perçu (année)</p><p className="text-lg font-bold text-[#008A8D]">{eur(stats.total_net_year)}</p></div>
            </div>

            <div className="realease-card p-6 mb-6">
              <h3 className="font-semibold text-gray-900 mb-4">Historique des loyers</h3>
              {payments.length === 0 ? <p className="text-sm text-gray-400">Aucun encaissement pour le moment.</p> : (
                <table className="w-full text-sm">
                  <thead>
                    <tr className="text-left text-xs text-gray-500 uppercase border-b border-gray-100">
                      <th className="py-2 pr-4">Période</th><th className="py-2 pr-4 text-right">Loyer</th>
                      <th className="py-2 pr-4 text-right">Honoraires</th><th className="py-2 pr-4 text-right">Net versé</th>
                      <th className="py-2">Documents</th>
                    </tr>
                  </thead>
                  <tbody>
                    {payments.map(p => (
                      <tr key={p.payment_id} className="border-b border-gray-50" data-testid={`portal-payment-${p.payment_id}`}>
                        <td className="py-2.5 pr-4 font-medium">{periodLabel(p.period)}</td>
                        <td className="py-2.5 pr-4 text-right">{eur(p.rent_received)}</td>
                        <td className="py-2.5 pr-4 text-right text-gray-500">- {eur(p.fees)}</td>
                        <td className="py-2.5 pr-4 text-right font-semibold text-[#008A8D]">{eur(p.net_owner)}</td>
                        <td className="py-2.5">
                          <div className="flex gap-3">
                            {p.report_doc_id && <a href={`${API}/gestion/documents/${p.report_doc_id}/pdf`} target="_blank" rel="noreferrer" className="text-xs text-[#008A8D] hover:underline" data-testid={`portal-report-${p.payment_id}`}>Compte rendu</a>}
                            {p.quittance_doc_id && <a href={`${API}/gestion/documents/${p.quittance_doc_id}/pdf`} target="_blank" rel="noreferrer" className="text-xs text-gray-500 hover:underline" data-testid={`portal-quittance-${p.payment_id}`}>Quittance</a>}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>

            {documents.filter(d => d.type === 'mandat_signe').length > 0 && (
              <div className="realease-card p-6">
                <h3 className="font-semibold text-gray-900 mb-3">Vos mandats signés</h3>
                <div className="space-y-2">
                  {documents.filter(d => d.type === 'mandat_signe').map(d => (
                    <a key={d.doc_id} href={`${API}/gestion/documents/${d.doc_id}/pdf`} target="_blank" rel="noreferrer"
                      className="flex items-center gap-2 text-sm text-[#008A8D] hover:underline" data-testid={`portal-mandate-${d.doc_id}`}>
                      📄 {d.filename}
                    </a>
                  ))}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ClientPortalGestion;
